import classNames from "classnames";
import Image from "next/image";
import { ROUTES } from "@/config";
import { AnchorButton } from "@narrative-software/narrative-web-ui";

interface EditLaunchPromoSectionType {
  title: string;
  subtitle: string;
  description: string;
  ctaText: string;
  compact: boolean;
}

// Fragment
const editLaunchPromoSectionFragment = `
  fragment editLaunchPromoSectionFragment on EditLaunchPromoSectionRecord {
    title
    subtitle
    description
    ctaText
    compact
  }
`;

function EditLaunchPromoSection({ title, subtitle, description, ctaText, compact }: EditLaunchPromoSectionType) {
  return (
    <section
      className={classNames("relative text-white", {
        "py-40 md:py-56": !compact,
        "py-28": compact,
      })}
    >
      <Image
        src={`/images/edit/launch-sale-bg-${compact ? "sm" : "lg"}.webp`}
        alt=""
        className="absolute top-0 right-0 bottom-0 left-0"
        layout="fill"
        objectFit="cover"
        objectPosition="center"
        sizes="100vw"
        draggable={false}
      />
      <div
        className="absolute top-0 right-0 bottom-0 left-0"
        style={{ background: "radial-gradient(circle, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%)" }}
      />
      <div className="flex flex-col items-center relative text-center px-8">
        <h2
          className={classNames("font-semibold leading-tight", {
            "text-4xl md:text-5xl": !compact,
            "text-3xl md:text-4xl": compact,
          })}
        >
          {title}
          <br />
          <span className="text-jolteon">{subtitle}</span>
        </h2>
        <div className="mt-5 mb-7" dangerouslySetInnerHTML={{ __html: description }} />
        <AnchorButton colour="ekans" className="max-w-90" href={`/${ROUTES.EDIT.PRICING.SLUG}`}>
          {ctaText}
        </AnchorButton>
      </div>
    </section>
  );
}

export { EditLaunchPromoSection, editLaunchPromoSectionFragment };
export type { EditLaunchPromoSectionType };
